import axios from "axios";

import Config from "src/config";

const v3_marketing_listarJobs_action = campanhaId => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/v3/marketing/campanhas/${campanhaId}/jobs`,
    });
};

export default v3_marketing_listarJobs_action;
